import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import {Routes} from './Routes';
import {I18nProvider} from '../_metronic/i18n';
import {LayoutSplashScreen, HeaderProvider} from '../_metronic/layout';
import {CacheProvider} from './modules/_common/components/AppCahce/AppCache';
import {GlobalProvider} from "./modules/_common/contexts/GlobalContext";

export default function App({store, persistor, basename}) {
  return (
    <CacheProvider>
      {/* Provide Redux store */}
      <Provider store={store}>
        <GlobalProvider>
          <HeaderProvider>
            {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
            <PersistGate persistor={persistor} loading={<LayoutSplashScreen/>}>
              {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
              <React.Suspense fallback={<LayoutSplashScreen/>}>
                {/* Override `basename` (e.g: `homepage` in `package.json`) */}
                <BrowserRouter basename={basename}>
                  {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
                    {/* Provide `react-intl` context synchronized with Redux state.  */}
                    <I18nProvider>
                      {/* Render routes with provided `Layout`. */}
                      <Routes/>
                    </I18nProvider>
                </BrowserRouter>
              </React.Suspense>
            </PersistGate>
          </HeaderProvider>
        </GlobalProvider>
      </Provider>
    </CacheProvider>
  );
}
